
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/ckan/training",
      function () {
        return require("private-next-pages/solutions/ckan/training.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/ckan/training"])
      });
    }
  